<template>
    <div>
        <compWrapper title="编辑发货地址" theme="primary" >
            <compFormQuery
                v-if="type=='query'"
                class="margin-layout width-50per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
                :col="1"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-layout width-50per"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1"
            />
            <div class="text-right padding-bottom-20 padding-right-20" v-if="type!='query'">
                <Button type="primary" @click="submit">保存</Button>
                <Button class="margin-left-10" @click="cancel">取消</Button>
            </div>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpSaveAddress,HttpGetAddressDetail } from "@/service/bespeak";
import { HttpGetLog } from "@/service/fedex";
export default {
    props:['activeids','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeids,
            formData:{},
            loading:false,
            opLogList:[],
        }
    },
     computed:{
        ...mapGetters('dictionary', ['getNextOrgList','getCountryList']),
        getBase(){
            return [
                {
                    label: '客户',
                    key: 'orgId',
                    tag: 'Select',
                    options:this.getNextOrgList,
                    props:{
                        filterable:true,
                        clearable:true,
                    },
                    query:this.type!='add'
                },
                {
                    label: '目的地地址COde',
                    key: 'addressCode',
                },
                {
                    label: '国家',
                    tag: 'vInput',
                    key: 'country',
                    options:this.getCountryList,
                    props:{
                        filterable:true
                    },
                },
                {
                    label: '州/省份',
                    tag: 'vInput',
                    key: 'state',
                },
                {
                    label: '城市',
                    tag: 'vInput',
                    key: 'city',
                },
                {
                    label: '详细地址',
                    tag: 'vInput',
                    key: 'address',
                },
                {
                    label: '邮编',
                    tag: 'vInput',
                    key: 'postal',
                },
                {
                    label: '收件人',
                    tag: 'vInput',
                    key: 'linkman',
                    required:false,
                },
                {
                    label: '联系电话',
                    tag: 'vInput',
                    key: 'phone',
                    required:false,
                },
                {
                    label: '备注',
                    tag: 'vInput',
                    key: 'remark',
                    required:false,
                },
            ]
        },
        getLogcolumns(){
			return [
				{
					title: this.$t('global.common.operator', { defaultValue: '操作人' }),
					key: "updatedName"
				},
				{
					title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
					key: "operateType",
                    render:(h,{row})=>{
                        return <div>{row.operateType == 100 ? 
                            this.$t('global.common.create', { defaultValue: "创建" }) : 
                            this.$t('fbb.alloment.update	', { defaultValue: "更新" })}
                        </div>
                    }
				},
				{
					title: this.$t('global.common.notes', { defaultValue: '备注' }),
					key: "remark"
				},
				{
					title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
					key: "createdAt"
				}
			];
		}
    },
    created(){
        this.update();
    },
    methods:{
        update(){
            if(this.type=='add') return;
            if(this.querytype){
				this.type = this.querytype
            }else{
				this.type = this.type
			}
            HttpGetAddressDetail({
                id:this.id
            }).then(res=>{
                this.formData = res.data.data;
                this.opLogList = res.data.logs
            })
        },
        async submit(){
            const valid = await this.$refs.editform.validate();
            if (!valid) return;
            
            this.loading = true;
            HttpSaveAddress({
                type:1,
                ...this.formData
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.cancel()
                this.loading = false;
            },err=>{
                this.loading = false;
                this.$VMessage.error(err.message);
            })
        },
        cancel(){
            this.$router.push({
                name: 'addressreceiveList',
            });
        }
    }
}
</script>